const de = {
    language: 'de',
    startseite: {
        ueberschrift: 'Herzlich Willkommen im PubKon+',
        paragraph1: 'Der PubKon+ ist eine Erweiterung des AUTEC-Konfigurators. Mit wenigen Klicks können Ihre Kunden selbst eine Konfiguration von A bis Z vornehmen.',
        paragraph2: 'Der PubKon+ kann sowohl über Ihre Homepage als auch mobile Endgeräte - z.B. in Ihrem Verkaufsraum, aufgerufen werden.',
        paragraph3: {
            zeile1: 'Haben wir Ihr Interesse geweckt?',
            zeile2: 'Bitte kontaktieren Sie uns, wir beraten Sie gerne.',
        },
        paragraph4: {
            labelTelefon: 'Tel.:',
            valueTelefon: '06235 / 9266-0',
            linkTelefon: '+49623592660',
            labelEmail: 'Email:',
            valueEmail: 'info@autec-wheels.de',
            linkEmail: 'info@autec-wheels.de',
            buttonZurAnwendung: 'Weiter zur Anwendung',
            labelButtonZurAnmeldung: 'Bereits registriert?',
            buttonZurAnmeldung: 'Weiter zur Anmeldung',
        },
    },
    navigation: {
        ueberschrift: 'Herzlich Willkommen im PubKon+',
        sortiment: 'Produktsortiment verwalten',
        preise: 'Preise verwalten',
        agb: 'Händler-AGB',
        layout: 'Layout anpassen',
        schnittstellen: 'Schnittstellen',
        einbinden: 'Einbinden',
    },
    loginForm: {
        messageUsername: 'Bitte tragen Sie einen Wert im Feld \'Benutzername\' ein!',
        platzhalterUsername: 'Benutzername',
        messagePassword: 'Bitte tragen Sie einen Wert im Feld \'Passwort\' ein!',
        platzhalterPassword: 'Passwort',
        buttonLogin: 'Login',
    },
    sortiment: {
        panelHeader: {
            fahzeugauswahl: 'Fahrzeughersteller',
            radtypauswahl: 'AUTEC-Raddesigns',
            weitere: 'Weitere Produktgruppen',
        },
        fahrzeugAuswahl: {
            messageGespeichert: 'Sortiment gespeichert!',
            buttonAlleAbwaehlen: 'Alle abwählen',
            buttonAlleAuswaehlen: 'Alle auswählen',
            buttonVerwerfen: 'Änderungen verwerfen',
            buttonSpeichern: 'Speichern'

        },
        radtypenAuswahl: {
            messageGespeichert: 'Sortiment gespeichert!',
            buttonAlleAbwaehlen: 'Alle abwählen',
            buttonAlleAuswaehlen: 'Alle auswählen',
            buttonVerwerfen: 'Änderungen verwerfen',
            buttonSpeichern: 'Speichern'
        },
        produktgruppen: {
            rdks: 'RDKS',
            komplettraeder: 'Kompletträder',
            messageGespeichert: 'Produktgruppen gespeichert!',
            buttonVerwerfen: 'Änderungen verwerfen',
            buttonSpeichern: 'Speichern'
        }
    },
    preise: {
        tabs: {
            preise: "Preise",
            umsatzsteuer: "Umsatzsteuer"
        },
        preise: {
            messageCodes: {
                ALTERNATIVE_PREISREGEL_UNBEKANNTER_FEHLER: "Es ist ein unbekannter Fehler aufgetreten.",
                ALTERNATIVE_PREISREGEL_ERFOLGREICH_GESPEICHERT: "Kalkulation gespeichert.",
                ALTERNATIVE_PREISREGEL_NEGATIVE_ABSCHLAEGE_UNZULAESSIG_FEHLER: "Negative Abschläge sind unzulässing."
            },
            pflichtangabe: 'ist Pflichtangabe.',
            columns: {
                groesse: 'Größe',
                aufschlagProzent: 'Aufschlag in Prozent',
                aufschlagEuro: 'Aufschlag in Euro'
            },
            paragraph1: {
                ueberschrift: 'Bei der aktuellen Kalkulation für den PubKon+ handelt es sich um Richtwerte der AUTEC GmbH & Co. KG. Diese sind grau hinterlegt und können bei Bedarf individuell angepasst werden.',
                ueberschriftNichtGespeichert: 'Achtung! Änderungen noch nicht gespeichert.'
            },
            paragraph2: {
                ueberschrift: 'Kalkulation',
                ueberschriftRot: 'Bitte berücksichtigen Sie bei Ihrer Kalkulation die entstehenden Frachtkosten.'
            },
            paragraph3: {
                ueberschrift: 'Räder',
            },
            paragraph4: {
                ueberschrift: 'Kompletträder (Programmkompletträder)',
                beschreibung: 'Hierbei handelt es sich ausschließlich um unser vordefiniertes Komplettradprogramm mit attraktiven Preisen und sofortiger Verfügbarkeit. Im Webshop sind diese als "Unsere Empfehlung" gekennzeichnet. Der Preis für individuell zusammengestellte Kompletträder setzt sich wie folgt zusammen: Vereinbarter Nettoeinkaufspreise für Räder, RDKS und Reifen inkl. Montage zzgl. Steuer.'
            },
            paragraph5: {
                ueberschrift: 'Reifen',
                beschreibung: 'Die Kalkulation der Reifenpreise ist lediglich für die Verwendung der Reifen zum Erstellen eines individuellen Komplettrades notwendig.'
            },
            paragraph6: {
                ueberschrift: 'RDKS',
            },
            sternchenText: {
                eins: 'Die Aufschläge in Prozent beziehen sich auf Ihren Einkaufspreis.',
                zwei: 'Bitte die Aufschläge Netto angeben.'
            },
            buttons: {
                vorgabenLaden: 'Aktuelle AUTEC-Vorgaben laden',
                verwerfen: 'Änderungen verwerfen',
                speichern: 'Speichern'
            }

        },
        umsatzsteuer: {
            keineDaten: 'Keine Daten',
            messageCodes: {
                UST_ERFOLGREICH_GELOESCHT: "Das Löschen war erfolgreich.",
                UST_ERFOLGREICH_GESPEICHERT: "Das Speichern war erfolgreich.",
                UST_UNBEKANNTER_FEHLER: "Es ist ein unbekannter Fehler aufgetreten.",
                UST_DATUME_SCHON_VORHANDEN: "Es gibt bereits einen Datensatz mit diesem Datum.",
                UST_ALLGEMEINER_FEHLER_SPEICHERN: "Das Speichern hat leider nicht geklappt.",
                UST_LOESCHEN_FEHLER: "Das Löschen hat leider nicht geklappt."
            },
            columns: {
                steuersatz: 'Umsatzsteuersatz',
                gueltigAb: 'Gültig ab',
                aktion: 'Aktion'
            },
            popupLoeschen: {
                ueberschrift: 'Soll dieser Umsatzsteuersatz wirklich gelöscht werden?',
                okText: 'Löschen',
                cancelText: 'Abbrechen',
            },
            erstellen: {
                ueberschriftNeu: 'Neuer Umsatzsteuersatz',
                ueberschriftEditieren: 'Umsatzsteuersatz editieren',
                form: {
                    steuersatz: 'Umsatzsteuersatz in %',
                    gueltigAb: 'Gültig ab',
                },
            },
            buttons: {
                abbrechen: 'Abbrechen',
                speichern: 'Speichern'
            },
            aktuellerSatz: 'Aktueller Umsatzsteuersatz',
        }
    },
    agb: {
        messages: {
            speichernErfolgreich: 'Speichern der AGB Einstellung war erfolgreich.',
            speichernFehlgeschlagen: 'Speichern der AGB Einstellung fehlgeschlagen.'
        },
        alert: {
            message: 'Es ist noch keine gültige AGB-Konfiguration im System hinterlegt.'
        },
        paragraph1: {
            ueberschrift: 'Hier können Sie Ihre AGB zur Anzeige im PubKon+ hinterlegen.',
            radioOptionOne: 'Benutzen Sie folgende URL, um im PubKon+ Ihre AGB anzuzeigen:',
            radioOptionTwo: 'Laden Sie eine eigene AGB-Datei hoch, um diese im PubKon+ anzuzeigen.'
        },
        paragraph2: {
            uploadError: 'Dateityp unzulässig',
            dataiLeseError: 'Fehler beim Lesen der Datei',
        },
        auswaehlenButton: 'AGB-Datei auswählen',
        herunterladenButton: 'Aktuelle AGB herunterladen',
        speichernButton: 'Speichern'
    },
    layout: {
        logoUpload: {
            checkbox: 'PubKon+ mit eigenem Logo',
            keinLogo: 'Es wurde noch kein Logo hochgeladen.',
            vorschauLabel: 'Vorschau des aktuellen Logos',
            austauschHinweis: 'Logo wird durch die getroffene Auswahl beim Speichern aktualisiert.',
            unzulaessigerDateityp: 'Dateityp unzulässig',
            dateilesefehler: 'Fehler beim Lesen der Datei',
            neuesLogoAuswaehlen: 'Neues Logo auswählen',
            logoposition: 'Logoposition',
            links: 'Links',
            mitte: 'Mitte',
            rechts: 'Rechts',
            kopfzeileMitHintergrund: 'Kopfzeile mit Hintergrundfarbe',
            kopfzeilenfarbe: 'Kopfzeilenfarbe',
            kopfzeilenfarbeErklaerung: 'Wenn eine Kopfzeile mit Logo angezeigt und eine Hintergrundfarbe genutzt werden soll, ist diese Farbe die verwendete Farbe.',

        },
        messages: {
            speichernErfolgreich: 'Änderungen erfolgreich übernommen.',
            speichernFehlgeschlagen: 'Beim Speichern der Änderungen ist möglicherweise ein Fehler aufgetreten.',
        },
        farbenEingabe: {
            primary: {
                label: 'Primärfarbe',
                erklaerung: 'Ersetzt die Bereiche, die im Konfigurator auf der AUTEC-Homepage rot, bzw. im Konfigurator im AUTEC-Webshop gold sind.',
            },
            secondary: {
                label: 'Sekundärfarbe',
                erklaerung: 'Ersetzt das Grün einiger Buttons.',
            },
            text: {
                label: 'Textfarbe',
                erklaerung: 'Ersetzt die Textfarbe im Konfigurator.',
            },
        },
        buttons: {
            standard: 'Standardwerte einsetzen',
            reset: 'Änderungen verwerfen',
            speichern: 'Speichern',
        }
    },
    kontaktdaten: {
        messageSpeichernErfolgreich: 'Kontakteinstellungen gespeichert!',
        messageSpeichernFehlgeschlagen: 'Kontakteinstellungen speichern fehlgeschlagen!',
        ueberschrift: 'Übermittlung einer gespeicherten Konfiguration',
        checkbox: {
            haendlerEmail: 'An meine E-Mail-Adresse schicken',
            haendlerEmailMitPdf: 'PDF-Datei an E-Mail anhängen',
            haendlerEmailMitCSV: 'CSV-Datei an E-Mail anhängen',
            haendlerSftp: 'Auf meinen SFTP-Server hochladen',
            haendlerSftpMitPdf: 'PDF-Datei hochladen',
            haendlerSftpMitCSV: 'CSV-Datei hochladen',
            erlaubeKundenEmail: 'Kunde kann PubKon+ Konfiguration an seine E-Mail schicken lassen',
            erlaubeKundenPdf: 'Kunde kann PubKon+ Konfiguration als PDF herunterladen',
            erlaubeSpeichernFuerShokon: 'Kunde darf PubKon+ Konfiguration im Webshop (Warenkorb) speichern',
        },
        email: {
            ueberschrift: 'Gespeicherte Konfiguration senden an',
            labelMeineEmail: 'Meine E-Mail',
        },
        smtpSettings: {
            messages: {
                testErfolgreich: 'Mit den gegebenen Einstellungen konnte eine Verbindung zum SMTP-Server erfolgreich hergestellt werden.',
                testFehlgeschlagen: 'Mit den gegebenen Einstellungen konnte keine Verbindung zum SMTP-Server hergestellt werden.',
                speichernErfolgreich: 'Einstellungen erfolgreich gespeichert.',
                speichernFehlgeschlagen: 'Einstellungen speichern fehlgeschlagen.',
            },
            ueberschrift: 'Damit E-Mails verschickt werden können, muss eine gültige SMTP-Server Konfiguration vorliegen. Über diesen Server werden die E-Mails an Ihre Kunden und Sie verschickt.',
            alertKeineGueltigenEinstellungen: 'Es liegt noch keine SMTP-Server Konfiguration vor oder die Absender E-Mail-Adresse fehlt. Bitte konfigurieren Sie unten einen SMTP-Server, damit E-Mails mit PubKon+ Konfigurationen an Sie und Ihre Kunden verschickt werden können.',
            labels: {
                absenderEmail: 'Absender-E-Mail',
                absenderEmailHinweis: '(Mit dieser E-Mail-Adresse werden die Konfigurationen verschickt)',
                smtpServer: 'SMTP-Server',
                smtpPort: 'SMTP-Port',
                smtpBenutzer: 'SMTP-Benutzer',
                smtpVerbindungsicherheit: 'SMTP-Verbindungssicherheit',
                smtpPasswortHinweis: 'Aus Sicherheitsgründen wird Ihr aktuelles Passwort nicht angezeigt. Falls Sie Ihr Passwort nicht ändern wollen, lassen Sie das folgende Feld bitte leer.',
                smtpPasswort: 'SMTP-Passwort',
            }
        },
        sftpSettings: {
            messages: {
                testErfolgreich: 'Mit den gegebenen Einstellungen konnte eine Verbindung zum SFTP-Server erfolgreich hergestellt werden.',
                testFehlgeschlagen: 'Mit den gegebenen Einstellungen konnte keine Verbindung zum SFTP-Server hergestellt werden.',
                speichernErfolgreich: 'Einstellungen erfolgreich gespeichert.',
                speichernFehlgeschlagen: 'Einstellungen speichern fehlgeschlagen.',
                UNKNOWN_ERROR: 'Es ist ein unbekannter Fehler aufgetreten. Bitte kontrollieren Sie Ihre Eingabe, versuchen es später erneut oder wenden sich an uns, falls das Problem weiterhin besteht.',
                NO_SUCH_DIRECTORY_ERROR: 'Der angegebene Pfad ist kein Ordner.',
                UNSUPPORTED_OPERATION_ERROR: 'Eine SFTP Operation wird nicht unterstützt.',
                AUTH_ERROR: 'Die Authentifizierung mit Ihrer Benutzer-/Passwortkombination ist Fehlgeschlagen. Bitte überprüfen Sie diese und versuchen es erneut.',
                MISSING_INFORMATION_ERROR: 'Eine Information in Ihren SFTP Einstellungen fehlt. Bitte überprüfen Sie Ihre Einstellungen und versuchen es erneut.',
                TIMEOUT_ERROR: 'Verbindung zum SFTP-Server konnte wegen eines Timeouts nicht hergestellt werden. Bitte überprüfen Sie Ihre Einstellungen und versuchen es erneut.',
            },
            ueberschrift: 'Damit Dateien auf Ihren SFTP-Server hochgeladen werden können, muss eine gültige Konfiguration vorliegen.',
            alertKeineGueltigenEinstellungen: 'Es liegt noch keine SFTP-Server Konfiguration vor. Bitte konfigurieren Sie unten einen SFTP-Server, damit Dateien PubKon+ Konfigurationen hochgeladen werden können.',
            labels: {
                sftpServer: 'SFTP-Server',
                sftpPort: 'SFTP-Port',
                sftpBenutzer: 'SFTP-Benutzer',
                sftpPfad: 'SFTP-Pfad',
                sftpPasswortHinweis: 'Aus Sicherheitsgründen wird Ihr aktuelles Passwort nicht angezeigt. Falls Sie Ihr Passwort nicht ändern wollen, lassen Sie das folgende Feld bitte leer.',
                sftpPasswort: 'SFTP-Passwort',
            }
        },
        buttons: {
            verwerfen: 'Änderungen verwerfen',
            testen: 'Einstellungen testen',
            speichern: 'Speichern'
        }

    },
    einbinden: {
        downloadFile: {
            noscript: 'JavaScript muss aktiviert sein, damit der Konfigurator funktioniert.'
        },
        stepOne: {
            ueberschrift: '1. Den PubKon+ auf der eigenen Homepage einbinden. Bitte kontaktieren Sie Ihren Web-Entwickler.',
            paragraph1: 'Der folgende Code muss im head-Tag auf Ihrer Webseite hinzugefügt werden.',
            paragraph2: 'Der folgende Code muss im body-Tag auf Ihrer Webseite an der Stelle hinzugefügt werden, an der der PubKon+ erscheinen soll.',
        },
        stepTwo: {
            ueberschrift: '2. Den PubKon+ über einen externen Link aufrufen.',
            preLinkText: 'Alternativ können Sie den PubKon+ unter',
            postLinkText: 'direkt aufrufen.'
        },
        stepThree: {
            ueberschrift: '3. Den PubKon+ als HTML-Datei herunterladen.',
            paragraph1: 'Als weitere Alternative können Sie folgende individuelle HTML-Datei herunterladen. Auf einem beliebigen mit dem Internet verbundenen Gerät kann über einen Browser (wir empfehlen Chrome oder Firefox) dann der PubKon+ angezeigt werden.',
            button: 'Herunterladen'
        }
    },
};

export default de;